<template>
  <div>
    <generic-container
      :title="$t('course')"
      icon="book"
      :show_plus="true"
      :configurable="true"
      v-bind:configure_modal="configure_modal"
      v-on:add="add"
      :header_buttons="header_buttons"
    >
      <table
        class="ui blue very compact celled striped selectable table"
        ref="table"
        style="width:100%"
      >
        <thead>
          <tr>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("description") }}</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </generic-container>
    <template v-for="(mdl, index) in course_modals">
      <component
        :is="mdl"
        :key="index"
        v-on:destroy="destroy"
        v-on:succedded="succedded"
        :course_in="selected_course"
      ></component>
    </template>
  </div>
</template>

<script>
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./configuration_modal/Index.vue";
import CourseModal from "./course_modal/CourseModalIndex";
import { init_ajax_data_datables } from "@/utils";

// @ is an alias to /src
export default {
  name: "CourseIndex",
  components: {
    "generic-container": GenericContainer,
  },
  filters: filters,
  data() {
    return {
      courses: [],
      configure_modal: ConfigureModal,
      course_modals: [],
      selected_course: undefined,
      header_buttons: [
        {
          icon: "refresh",
          tooltip: this.$t("refresh"),
          click: this.refresh,
        },
      ],
    };
  },
  methods: {
    add() {
      this.course_modals.push(CourseModal);
    },
    succedded(course) {
      let trgtIdx = this.courses.findIndex((n) => n.uuid == course.uuid);
      if (trgtIdx == -1) {
        this.courses.push(course);
      } else {
        this.courses.splice(trgtIdx, 1, course);
      }
    },
    destroy() {
      this.course_modals = [];
      this.selected_course = {};
      this.refresh();
    },
    show_course(course) {
      this.selected_course = course;
      this.course_modals.push(CourseModal);
      // this.customer = customer;
      // this.$router.push({
      //   name: "StudentView",
      //   query: { i: course.uuid },
      // });
    },
    refresh() {
      let vm = this;
      var table = window.jQuery(vm.$refs.table).DataTable();
      if (table) table.ajax.reload();
    },
  },
  created() {},
  mounted() {
    let vm = this;

    let columns = [
      {
        data: function(row) {
          return row.name || "";
        },
      },
      {
        data: function(row) {
          return row.description || "";
        },
      },
    ];

    let onSelect = (data) => {
      vm.show_course(data);
    };

    init_ajax_data_datables(
      vm,
      vm.$refs.table,
      window.jQuery.fn.api.settings.api["course url"],
      columns,
      onSelect,
    );
  },
  watch: {},
};
</script>
